import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import ProductDetail from '../ProductDetail'
import NoImage from '../../Assets/Images/Logos/no-image.png'
import cmfArrow from '../../Assets/Images/Product/cmf_arrow.svg'
import Modal from 'react-bootstrap/Modal'
import './product.css'
import { useDispatch, useSelector } from 'react-redux'
import { addToList } from '../../redux/actions/listActions'
import { showProductsList } from '../../redux/actions/productActions.js'
import { handleAddProductToCart, toTitleCase } from '../../Utils/functions'
import GenericModal from 'Components/GenericModal'
import { t } from 'i18next'
import { animateScroll as scroll } from 'react-scroll'
import aa from 'search-insights'
import { useProductSearchContext } from 'state/context/ProductSearchContext'
import {
  calculateHitPosition,
  getPositionOnPage,
} from 'Utils/Helpers/calculateHitPosition'
import WarningModal from 'Components/WarningModal/WarningModal'
import { Formatter } from 'Utils/Formatter'
import NetworkErrorAlert from '../NetworkErrorAlert'

aa('init', {
  appId: 'ZCZRBTYD8I',
  apiKey: '6c9235a951666253b5b003e1cf34d9ce',
})

function Product({
  product,
  productsRef,
  inListScreen,
  setShowMaterialsCalculatorPDP,
  setProductDetail,
}) {
  const location = useLocation()
  const isEditCoti = location.pathname.includes('editar_cotizacion')
  const cart = useSelector(state => state.cart.cart)
  const [isOpen, setIsOpen] = useState(false)
  const [showMessage, setShowMessage] = useState(false)
  const [inactiveMessage, setInactiveMessage] = useState(false)
  const [showNetworkErrorAlert, setShowNetworkErrorAlert] = useState(false)
  const [apiErrorMessage, setApiErrorMessage] = useState(null)
  const [openWithInventario, setOpenWithInventario] = useState(null)
  const [name, setName] = useState('')
  const customerId = useSelector(
    state => state.cotizacion?.QuoteHeader?.CustomerId
  )
  const [showAlertDontAddProduct, setShowAlertDontAddProduct] = useState(false)
  const dispatch = useDispatch()
  const [closeWarningModal, setCloseWarningModal] = useState(false)
  const cotizacion = useSelector(state => state.cotizacion?.QuoteHeader)

  const { calculateAlgoliaHitPosition } = useProductSearchContext()
  const algoliaIndex = useSelector(
    state => state?.login?.checkCompany?.[0].InitialCatalog
  )

  // CART
  // const cart = useSelector(state => state.cart.cart)
  const channelRef = useRef(null)

  if (!channelRef.current) {
    channelRef.current = new BroadcastChannel('customer_display')
  }

  const handleClose = useCallback(() => {
    setIsOpen(false)

    channelRef.current.postMessage({
      isProductDetail: false,
    })
  }, [])

  useEffect(() => {
    const channel = channelRef.current
    channel.onmessage = event => {
      if (event.data.isCloseDetailProduct) handleClose()
    }
  }, [handleClose])

  const handleOpen = inventario => {
    if (!inListScreen) {
      scroll.scrollToTop({
        delay: 0,
        smooth: 'linear',
        duration: 1,
      })
      setIsOpen(true)
      if (!inventario) {
        channelRef.current.postMessage({
          isProductDetail: true,
          isLoadingProductDetail: true,
          isSearchProducts: false,
          productDetail: product,
        })
      }
      dispatch(showProductsList(false))
      setOpenWithInventario(inventario)
    }
  }

  const handleCloseModal = () => {
    setCloseWarningModal(false)
  }

  useEffect(() => {
    setName(toTitleCase(product?.Brand))
  }, [product])

  const colorBadge = quantity => {
    if (quantity > 4) {
      return '#11D29E'
    } else if (quantity <= 4 && quantity >= 2) {
      return '#FFDE20'
    } else {
      return '#FF2A40'
    }
  }

  const handleClick = hit => {
    const pageData = calculateAlgoliaHitPosition.find(p =>
      p.hits.some(h => h.objectID === hit.objectID)
    )

    const queryID = pageData?.queryID || ''

    const positionIndexHit = getPositionOnPage(
      pageData?.hits || [],
      hit.objectID
    )

    const hitPosition = calculateHitPosition(
      positionIndexHit,
      pageData.page,
      20
    )
    // register the click event
    aa('clickedObjectIDsAfterSearch', {
      eventName: 'PRODUCT_DETAILS',
      index: algoliaIndex,
      objectIDs: [hit.objectID],
      positions: hitPosition,
      queryID,
      userToken: aa('getUserToken'),
    })
  }

  const handleConversion = hit => {
    const pageData = calculateAlgoliaHitPosition.find(p =>
      p.hits.some(h => h.objectID === hit.objectID)
    )

    const queryID = pageData?.queryID || ''

    aa('convertedObjectIDsAfterSearch', {
      eventName: 'ADDED_TO_QUOTE',
      index: algoliaIndex,
      objectIDs: [hit.objectID],
      queryID,
      userToken: aa('getUserToken'),
    })
  }

  return (
    <>
      <WarningModal open={closeWarningModal} onClose={handleCloseModal} />
      <div
        className="product-card-wrapper"
        data-testid={`card-product-wrapper-${product?.ProductId}`}>
        <div
          className="product-card"
          onClick={() => handleClick(product)}
          data-testid={`card-product-${product?.sku}`}>
          <div>
            <div
              className="product-card-image"
              id="product-card-image"
              data-testid={`container-product-image-${product?.Sku}`}
              onClick={() => handleOpen(false)}>
              <img
                src={(product.Images && product.Images[0].URL) || NoImage}
                alt={product.ProductName}
                className="img-fluid"
              />
            </div>
            <div
              className="product-card-generals"
              data-testid={`container-product-info-${product?.Sku}`}>
              <h2
                onClick={() => handleOpen(false)}
                className="product-card-generals-title"
                data-testid={`product-name-${product?.Sku}`}>
                {product.ProductName}
              </h2>
              <p
                className="product-card-brand"
                data-testid={`product-brand-${product?.Sku}`}>
                {name || 'Desconocido'}
              </p>
              <p
                className="product-card-sku"
                data-testid={`product-sku-${product?.Sku}`}>
                {product.Sku}
              </p>
              <div
                className="product-card-price"
                data-testid={`container-product-price-${product?.Sku}`}>
                <p data-testid={`product-final-price-${product?.Sku}`}>
                  {product.FinalPrice === undefined
                    ? 'Sin precio'
                    : '$' + Formatter.Money(product.FinalPrice)}
                </p>
                {(product.PriceListId ===
                  '39FC82DF-2B58-4DD1-BE9C-F50A317D7266' ||
                  product.PriceListId ===
                    'FDCA4798-57A8-42FC-A778-1E6471153A0B') && (
                  <img src={cmfArrow} alt="cmf-arrow" className="img-fluid" />
                )}
              </div>

              {product.BasePrice - product.FinalPrice > 0 && (
                <div className="product-card-discount-container">
                  <p className="product-card-discount">
                    {'Precio regular $' + product.BasePrice.toFixed(2)}
                  </p>
                </div>
              )}
              <div
                className="container-inventary-product"
                data-testid={`container-product-inventory-${product?.Sku}`}>
                <p
                  className="product-card-store"
                  data-testid={`product-warehouse-qty-${product?.Sku}`}>
                  Tienda{' '}
                  <span
                    style={{
                      backgroundColor: colorBadge(product.WarehouseQty),
                      borderRadius: '5px',
                      padding: '2px 6px',
                      display: 'inline-block',
                      fontWeight: 'bold',
                    }}>
                    {!product.WarehouseQty || product.WarehouseQty === undefined
                      ? 0
                      : product.WarehouseQty}
                  </span>{' '}
                </p>
                <p
                  className="product-card-store"
                  data-testid={`product-total-qty-${product?.Sku}`}>
                  Total{' '}
                  <span
                    style={{
                      backgroundColor: colorBadge(product.TotalQty),
                      borderRadius: '5px',
                      padding: '2px 6px',
                      display: 'inline-block',
                      fontWeight: 'bold',
                    }}>
                    {!product.TotalQty || product.TotalQty === undefined
                      ? 0
                      : product.TotalQty}
                  </span>{' '}
                </p>
              </div>
              {showMessage && (
                <p
                  className="product-no-price"
                  data-testid={`product-no-price-${product?.Sku}`}>
                  No se puede agregar, no cuenta con precio
                </p>
              )}
              {inactiveMessage && (
                <p
                  className="product-no-price"
                  data-testid={`product-inactive-message-${product?.Sku}`}>
                  {t('INACTIVE_PRODUCT_MESSAGE_T')}
                </p>
              )}
            </div>
          </div>
          <div className="product-card-buttons">
            {inListScreen ? (
              <button
                data-testid={`btn-product-add-to-list-${product?.Sku}`}
                onClick={() => {
                  dispatch(addToList(product))
                }}>
                Agregar a Lista
              </button>
            ) : (
              <button
                data-testid={`btn-product-add-to-list-${product?.Sku}`}
                onClick={async event => {
                  event.stopPropagation() // We use this to avoid send multiple algolia events, so we need to send only this 'handleConversion'

                  const wasAdded = await handleAddProductToCart({
                    product,
                    cotizacion,
                    isEditCoti,
                    setCloseWarningModal,
                    setInactiveMessage,
                    cart,
                    dispatch,
                    customerId,
                    setShowAlertDontAddProduct,
                    setShowMessage,
                    setShowNetworkErrorAlert,
                    setApiErrorMessage,
                  })

                  if (wasAdded) {
                    handleConversion(product)
                  }
                }}>
                Agregar
              </button>
            )}
            {inListScreen ? null : (
              <button
                data-testid={`btn-product-inventory-${product?.Sku}`}
                onClick={() => handleOpen(true)}>
                Inventario
              </button>
            )}
          </div>
          <div
            className="product-promo"
            style={{ display: product.Promo ? 'block' : 'none' }}>
            <p>{product.Promo || 'No Promo'}</p>
          </div>
          {product.BasePrice - product.FinalPrice > 0 && (
            <div className="product-promo">Oferta</div>
          )}
        </div>
        <div>
          <Modal
            show={isOpen}
            onHide={handleClose}
            container={productsRef.current}
            backdrop={false}
            enforceFocus={false}
            className="modal-clase-producto">
            <ProductDetail
              id={product.ProductId}
              productsRef={productsRef}
              producto_final={product}
              price={product.FinalPrice}
              cost={product.Cost || product.AvgCost || 0.0}
              openWithInventario={openWithInventario}
              handleClose={handleClose}
              setShowMaterialsCalculatorPDP={setShowMaterialsCalculatorPDP}
              setProductDetail={setProductDetail}
            />
          </Modal>
        </div>
        <div>
          {/* MODAL Alert dont Add producto to cart */}
          <Modal
            show={showAlertDontAddProduct}
            backdrop="static"
            className="modal-clase-price-change"
            centered>
            <GenericModal
              setIsOpen={() => setShowAlertDontAddProduct(false)}
              showCaution={true}
              hideCheck={true}
              text={t('GENERIC_MODAL.NO_INVENTORY_ALERT')}
              mostrarButtons={false}></GenericModal>
          </Modal>
        </div>
        <NetworkErrorAlert
          open={showNetworkErrorAlert}
          message={t('GENERIC_MODAL.NETWORK_ERROR_ADD_PRODUCT')}
          onClose={() => setShowNetworkErrorAlert(false)}
        />
        <NetworkErrorAlert
          open={apiErrorMessage !== null}
          message={
            t('GENERIC_MODAL.API_ERROR_ADD_PRODUCT') +
            (apiErrorMessage ? ': ' + apiErrorMessage : '.')
          }
          onClose={() => setApiErrorMessage(null)}
        />
      </div>
    </>
  )
}

export default Product
